export default  [
    {

        name: 'Tablet',
        width: '834px',
        height: '1194px'
    },
    {
        name: 'GenişEkran',
        width: '1024px',
        height: '900px'
    },
    {
        name: 'iPad Pro',
        width: '1024px',
        height: '1366px',
    },
    {
        name: 'Standart',
        width: '400px',
        height: '900px',
    },
    {
        name: 'iPhone12',
        width: '428px',
        height: '926px',
    },
    {
        name: 'Small',
        width: '360px',
        height: '926px',
    }



]